const validatePage = () => {
  if (window.digitalData &&
      window.digitalData.page &&
      window.digitalData.page.pageInfo &&
      window.digitalData.page.pageInfo.pageName &&
      window.digitalData.page.pageInfo.pageType) {
    return true;
  }
  return false;
};

const validateUser = () => {
  if (window.digitalData &&
      window.digitalData.user &&
      window.digitalData.user.profile &&
      window.digitalData.user.profile.authenticationStatus) {
    return true;
  }
  return false;
};

const tryInitialize = () => {
  if (validatePage() && validateUser()) {
    window.ddoInit(window.digitalData);
  }
};

export const setPage = (page) => {
  if (window.digitalData) {
    window.digitalData.page = page;
  }
  tryInitialize();
};

export const setPageInfo = (pageName, pageType, pageLoadEvent) => {
  const pageInfo = { pageName, pageType };

  if (pageLoadEvent !== undefined && pageLoadEvent !== null && pageLoadEvent !== '') {
    pageInfo.pageLoadEvent = pageLoadEvent;
  }

  if (window.digitalData !== undefined && !window.digitalData.page) {
    window.digitalData.page = {};
    window.digitalData.page.pageInfo = pageInfo;
  }

  tryInitialize();
};

export const setAdditionalPageInfo = (propertyName, additionalData) => {
  if (window.digitalData !== undefined && !window.digitalData.page) {
    window.digitalData.page = {};
    window.digitalData.page.category = { ...additionalData };
  }
};

export const setAuthenticationStatus = (authenticationStatus) => {
  window.digitalData.user = window.digitalData.user || {};
  window.digitalData.user.profile = window.digitalData.user.profile || {};

  window.digitalData.user.profile.authenticationStatus = authenticationStatus;
  tryInitialize();
};
